const ActionType = (actionType) => `UI_${actionType}`;

export const CAN_TOUCH = ActionType('CAN_TOUCH');
export const CHANGE_STATE = ActionType('CHANGE_STATE');
export const MAXIMIZE_GUIDE = ActionType('MAXIMIZE_GUIDE');
export const MINIMIZE_GUIDE = ActionType('MINIMIZE_GUIDE');

export const SHOW_AUTHENTICATION_DIALOG = ActionType('SHOW_AUTHENTICATION_DIALOG');
export const HIDE_AUTHENTICATION_DIALOG = ActionType('HIDE_AUTHENTICATION_DIALOG');
